module.exports = __webpack_public_path__ + "img/74.5e026a1f.jpg";